/* eslint-disable no-console */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState, useMemo } from 'react';
import BookingHeader from '../components/bookingHeader';
import { Layout, Tabs, Table, Button, Modal, message, Spin } from 'antd';
import NoDataEmpty from './../components/noDataEmpty';
import { getBookingRecord, verificationNumber, cancelBooking, getCountNum, evaluateBooking, modifyMemberProcessQuestion, getTabsCount } from '../api/request';
import BookingDetail from '../components/bookingDetail';
import { EvaluationPage } from '@gaodun.com/gui-pc';
import BookingEvaluateDetail from '../components/bookingEvaluateDetail';
import PersonalEvaluate from '../components/subscribeRecord/personalEvaluate';
import { isEvaluationjump, parseUrl } from '../utils';
import './../assets/css/SubscribeRecord.less';
import { renderServiceDegreeComp, BOOKING_WAY, BOOKING_SCENE } from '../components/ViewUtils';
import { getBookingDetail } from '../api/request';
import { getValue } from '../utils';

const { TabPane } = Tabs;
const { Content } = Layout;

let isNewEvaluation = false; //新老评价判断、、
let currentSelectItem = {}; //当前选中

const SubscribeRecord = (props) => {
    const [tabsKey, setTabsKey] = useState('0'); // tap
    const [loading, setLoading] = useState(false); // loading
    const [bookingDetailModalShow, setBookingDetailModalShow] = useState(false); // 详情modal
    const [bookingEvaluateModalShow, setBookingEvaluateModalShow] = useState(false); // 评价modal
    const [detailMode, setDetailMode] = useState(0); // 详情编辑
    const [editLoaidng] = useState(false); // 按钮loading
    const [getListData, setGetListData] = useState([]); // 列表数据
    const [currentTable, setCurrentTable] = useState(1); // 页码
    const [totalSize, setTotalSize] = useState(0); // 数据总数
    // 查看详情id
    const [bookingDetailId, setBookingDetailId] = useState(0);
    // 查看评价id
    const [customerId, setCustomerId] = useState(0);
    // 是否是测评
    const [isEvaluation, setIsEvaluation] = useState(0);
    // modal 是否关闭销毁
    const destroyOnClose = true;
    // 详情编辑
    const [editContext, setEditContext] = useState('');
    // 问题图片
    const [editPic, setEditPic] = useState('');
    // 是否支持取消
    const [supportCancel, setSupportCancel] = useState(true);
    // 时间段
    const [timeRange, setTimeRange] = useState('');
    // 评价modal 是否允许关闭
    const [bookingEvaluateModalClosable, setBookingEvaluateModalClosable] = useState(true);
    const [evaluateLoading, setEvaluateLoading] = useState(false);
    const [latestBookingTime, setLatestBookingTime] = useState(0);
    const [tabData, setTabData] = useState([]); // tab切换数据
    const [evaluateData, setEvaluateData] = useState({}); // 评价数据存储
    // booking detail 详情
    const [bookingDetail, setBookingDetail] = useState({});
    //查看评价内容的接口
    const [isLive, setIsLive] = useState(false);
    const [isRead, setIsReadly] = useState(false);

    const { evaluationReportId } = parseUrl();

    const getSubscribeData = async () => {
        setLoading(true);
        const params = {
            serviceTeamId: props.match.params.id,
            type: tabsKey,
            pageSize: 10,
            pageNum: currentTable,
            serverType: 'pc'
        };
        const { data } = await getBookingRecord(params);
        if (!data.status) {
            setGetListData(data.result.list || []);
            setTotalSize(data.result.totalSize);
        } else {
            message.warning(data.message || data.info);
        }
        setLoading(false);
    };
    /**
     * @description 检查预约状态, 科目次数
     */
    const _getBookingSubjects = async () => {
        const serviceTeamId = props.match.params.id;
        const { data } = await getCountNum({ serviceTeamId });
        if (data.status) {
            Modal.info({
                title: data.message || data.info,
                okText: '确定'
            });
            return;
        }
        if (!data.status) {
            setLatestBookingTime(data.result.latestCancelTime);         
        } else {
            message.warning(data.message || data.info);
        }
    };
    /**
     * @description 获取tab切换数据
     */
    const tapCountData = async () => {
        const serviceTeamId = props.match.params.id;
        const { data } = await getTabsCount({ serviceTeamId });
        if (!data.status) {
            setTabData(data.result);
        } else {
            message.warning(data.message || data.info);
        }
    };
    /**
     * @description 格式化状态
     * @param {*} status
     * @param {*} currentTab
     * @returns {*} 
     */
    const formatStatus = (status, currentTab) => {
        let res = '';
        if (status === 0) {
            res = '未开始';
        } else if (status === 1) {
            res = '上课中';
        } else if (status === 2) {
            res = '已结束';
        } else if (status === 3) {
            res = '已取消';
        }
        if (currentTab == 1) {
            res = '待评价';
        }
        return res;

    };
    useEffect(() => {
        tapCountData();
        _getBookingSubjects();
    }, []);
    useEffect(() => {
        getSubscribeData();
    }, [tabsKey, currentTable]);

    const callback = (key) => {
        setTabsKey(key);
        setCurrentTable(1);
    };

    /**
     * @description 获取booking详情
     */
    const _getBookingInfo = async (id) => {
        const params = {
            id,
            cancel: 0
        };
        const { data } = await getBookingDetail(params);
        if (!data.status) {
            const bookingDetailInfo = getValue(() => data.result);
            setBookingDetail(bookingDetailInfo);
        } else {
            message.warning(data.message || data.info);
        }
    };
    /**
     * @description 查看详情按钮
     * @param {*} id
     */
    const openDetailModal = async (data) => {
        currentSelectItem = data;
        isNewEvaluation = !!data.newEvaluation;
        const { serviceType } = data;
        setIsLive(serviceType === BOOKING_WAY.LIVE);
        setIsReadly(true);
        _getBookingInfo(data.id);
        setCustomerId(data.customerId);
        setBookingDetailId(data.id);
        setBookingDetailModalShow(true);
        setDetailMode(0);
    };

    /**
     * @description 点击评价按钮
     * @param {*} data
     */
    const openEvaluateModal = (data) => {
        bookingDetailModalShow && setBookingDetailModalShow(false);

        currentSelectItem = data;
        const { serviceType } = data;
        setIsLive(serviceType === BOOKING_WAY.LIVE);
        // 默认评价都走新的 评价 NPS 体系
        isNewEvaluation = true;
        setIsReadly(false);
        setCustomerId(data.customerId);
        _getBookingInfo(data.id);
        setBookingDetailId(data.id);
        setBookingEvaluateModalShow(true);
        setBookingEvaluateModalClosable(false);
    };
    const columns = useMemo(() => ([
        {
            title: '科目',
            dataIndex: 'subjectName',
            key: 'subjectName',
        },
        {
            title: '上课方式',
            dataIndex: 'serviceTypeName',
            key: 'serviceTypeName',
        },
        {
            title: '上课时间',
            dataIndex: 'timeRange',
            key: 'timeRange',
        },
        {
            title: '产品名称',
            dataIndex: 'productName',
            width: 300,
            key: 'productName',
        },
        {
            title: '状态',
            key: 'processStatus',
            dataIndex: 'processStatus',
            render: (text, record) => (
                <div className="status-content-wrapper">
                    {
                        <span className="pending">{formatStatus(text, tabsKey)}</span>
                    }
                    {
                        record.teacherRemind === 1 && text === 0 ? <span className="edit-btn-ui">问题待修改</span> : null
                    }
                </div>
            )
        },
        {
            title: '操作',
            key: 'action',
            render: (record) => (
                <>
                    {+tabsKey === 1 ? (
                        <>
                            <a onClick={() => openEvaluateModal(record)}>立即评价</a>
                            <a onClick={() => openDetailModal(record)}>查看详情</a>
                        </>
                    ) : (
                        <a onClick={() => openDetailModal(record)}>查看详情</a>
                    )}
                </>
            ),
        },
    ]), [tabsKey]);
    //过滤表情包
    const  removeEmoji=(content) => {
        return content.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '');
    };

    /**
     * @description 点击确定
     */
    const handleOk = async () => {
        if (detailMode === 1) {//编辑问题
            const res = await modifyMemberProcessQuestion({ type: isEvaluation, context:removeEmoji(editContext) , pic: editPic, processId: bookingDetailId });
            setDetailMode(0);
            if (res.data.status === 0 && res.data.result) {
                message.success('修改成功');
            } else {
                message.warning(res.data.message || res.data.info);
            }
        }
        setBookingDetailModalShow(false);
        getSubscribeData();
    };
    /**
     * @description 取消预约事件
     * @param {*} id
     */
    const handleCancelBooking = async (id) => {
        const { data } = await cancelBooking({ id });
        if (!data.status) {
            message.success('取消成功');
            setBookingDetailModalShow(false);
            window.location.reload();
        } else {
            message.warning(data.message || data.info);
        }
    };
    /**
     * @description 是否超过4小时
     * @param {String} time
     * @returns {Boolean} bool
     */
    const isOverOneDay = (time) => {
        const timeStr = time.substring(0, 16);
        const timeStamp = new Date(timeStr).getTime();
        return timeStamp - Date.now() > latestBookingTime * 3600 * 1000;
    };
    /**
     * @description 点击取消预约
     * @param {*} time 
     * @param {*} support 
     */
    const handleCancel = async (time, support) => {
        //取消编辑
        if (detailMode === 1) {
            setDetailMode(0);
            return;
        }
        // 如果不支持取消
        if (!support) {
            Modal.info({
                content: '该服务不支持取消，如有疑问请联系学管。',
                okText: '确定',
            });
            return;
        }
        // 如果上课时间 < 4 小时
        if (!isOverOneDay(time)) {
            Modal.info({
                content: `距上课时间小于${latestBookingTime}小时，不允许取消预约该服务。`,
                okText: '确定',
            });
            return;
        }
        //bookingDetailId
        let content = `当前距离上课时间＞${latestBookingTime}h，取消预约后，将返回私教服务的次数到您账户，请您注意查收。`;
        const res = await verificationNumber({ processId: bookingDetailId });
        if (res.data.status === 0) {
            if (res.data.result && res.data.result.spanCycle === 2) {
                content = '本次课程是上个预约周期预约，取消后次数将不做返还，请慎重操作。';
            }
        }
        Modal.confirm({
            title: '确认要取消本次私教服务预约吗？',
            content: (
                <p>{content}</p>
            ),
            okText: '确定',
            cancelText: '再想想',
            onOk() {
                handleCancelBooking(bookingDetailId);
            },
        });
    };

    const getBookingList = async () => {
        setEvaluateLoading(true);
        const { data } = await evaluateBooking(evaluateData);
        setEvaluateLoading(false);
        if (!data.status) {
            setBookingEvaluateModalShow(false);
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } else {
            message.warning(data.message || data.info);
        }
    };
    /**
     * @description 设置supportCancel
     * @param {*} support
     */
    const handleSetSupportCancel = (support) => {
        setSupportCancel(support);
    };
    /**
     * @description 设置timeRange
     * @param {*} time
     */
    const handleSetTimeRange = (time) => {
        setTimeRange(time);
    };
    /**
     * @description handleReceiveData 接收数据
     * @param {*} v
     */
    const handleReceiveData = (v) => {
        setEvaluateData(v);
    };
    /**
     * @description 点击提交评价
     */
    const handleEvaluate = async () => {
        if (!evaluationReportId) {
            // 表单验证
            if (!(evaluateData.isLike && evaluateData.resolveResult && evaluateData.studentComment && evaluateData.teachAttitude)) {
                message.warning('请填写完整');
                return;
            }
            // 此处是坑
            // 满意程度数据修正 1,非常满意 2,不满意 3,满意
            if (evaluateData.isLike == 1) {
                evaluateData.isLike = 2;
            } else if (evaluateData.isLike == 2) {
                evaluateData.isLike = 3;
            } else if (evaluateData.isLike == 3) {
                evaluateData.isLike = 1;
            }
        } else {
            // 表单验证
            if (!(evaluateData.contentValue && evaluateData.teachingAttitude && evaluateData.studentComment && evaluateData.networkQuality && evaluateData.isLike)) {
                message.warning('请填写完整');
                return;
            }
        }

        getBookingList();
    };

    // 待上课详情modal
    const BookingEvaluateModal = (
        <Modal
            destroyOnClose={destroyOnClose}
            footer={
                // 待上课时有取消预约按钮
                tabsKey === '0' ?
                    [
                        <Button
                            key="back"
                            onClick={() => handleCancel(timeRange, supportCancel)}
                        >{detailMode === 1 ? '取消' : '取消预约'}</Button>,
                        <Button
                            key="submit"
                            loading={editLoaidng}
                            onClick={handleOk}
                            type="primary"

                        >
                            {detailMode === 1 ? '确认修改' : '确定'}
                        </Button>]
                    : [
                        <Button
                            key="submit"
                            onClick={handleOk}
                            type="primary"
                        >
                            确定
                        </Button>]
            }
            onCancel={() => setBookingDetailModalShow(false)}
            title="预约详情"
            visible={bookingDetailModalShow}
            width={620}
        >
            {
                <>
                    {
                        isNewEvaluation ? (
                            <>
                                <EvaluationPage
                                    businessUnitId={customerId}
                                    courseId={0}
                                    footView={renderServiceDegreeComp(bookingDetail)}
                                    gotoEvaluation={() => {
                                        openEvaluateModal(currentSelectItem);
                                    }}
                                    isReadly={isRead}
                                    productType={4}// 11 私教
                                    scene={isLive ? BOOKING_SCENE.selfLive : BOOKING_SCENE.selfPhone} />
                                {
                                    (bookingDetail && bookingDetail.evaluationReply) ? (
                                        <div
                                            className="teacher-answer"
                                            style={{ marginTop: '-10px' }}
                                        >
                                            <div className="answer-title"><span style={{ fontWeight: 'bold' }}>老师回复</span></div>
                                            <div> <span dangerouslySetInnerHTML={{ __html: bookingDetail.evaluationReply.replyContent }} /> </div>
                                            <div><span style={{ color: 'rgb(204,204,204)' }} >{`${bookingDetail.evaluationReply.createdAt.year}-${bookingDetail.evaluationReply.createdAt.monthValue}-${bookingDetail.evaluationReply.createdAt.dayOfMonth}`}</span></div>
                                        </div>
                                    ) : null

                                }
                            </>
                        ) : (
                            <BookingDetail
                                bookingDetailId={bookingDetailId}
                                changeMode={(v, isEvaluationVal) => { setDetailMode(v); setIsEvaluation(isEvaluationVal || 0); }}
                                detailMode={detailMode}
                                editContext={editContext}
                                editContextChange={(v) => { setEditContext(v); }}
                                editPic={editPic}
                                editPicChange={(v) => { setEditPic(v); }}
                                gotoEvaluation={() => {
                                    setBookingDetailModalShow(false);
                                    setTimeout(() => {
                                        openEvaluateModal(currentSelectItem);
                                    }, 100);
                                }}
                                parentSetSupportCancel={handleSetSupportCancel.bind(this)}
                                parentSetTimeRange={handleSetTimeRange.bind(this)}
                                type={tabsKey} />
                        )
                    }
                </>
            }
        </Modal >
    );

    const getFooter = () => {
        return (
            bookingEvaluateModalClosable ?
                [
                    <Button
                        key="back"
                        onClick={() => setBookingEvaluateModalShow(false)}
                    >取消</Button>,
                    <Button
                        key="submit"
                        loading={evaluateLoading}
                        onClick={handleEvaluate}
                        type="primary"
                    >
                        提交评价
                    </Button>]
                :
                [
                    <Button
                        key="submit"
                        loading={evaluateLoading}
                        onClick={handleEvaluate}
                        type="primary"
                    >
                        提交评价
                    </Button>]
        );
    };
    // 待评价详情modal 已经评价详情
    const BookingDetailModal = (
        <Modal
            destroyOnClose={destroyOnClose}
            footer={isNewEvaluation ? null : getFooter()}
            maskClosable={bookingEvaluateModalClosable}
            onCancel={() => setBookingEvaluateModalShow(false)}
            title="课程评价"
            visible={bookingEvaluateModalShow}
            width={620}
        >
            {isNewEvaluation ? (
                <EvaluationPage
                    businessUnitId={customerId}
                    buttonPosition="right"
                    buttonText="提交评价"
                    footView={renderServiceDegreeComp(bookingDetail, true)}
                    gotoEvaluation={() => {
                        openEvaluateModal(currentSelectItem);
                    }}
                    isReadly={isRead}
                    onSubmit={() => {
                        setBookingEvaluateModalShow(false);
                        window.location.reload();
                    }}
                    productType={4}
                    scene={isLive ? BOOKING_SCENE.selfLive : BOOKING_SCENE.selfPhone} />
            ) : (
                evaluationReportId ? (
                    <PersonalEvaluate
                        bookingDetailId={bookingDetailId}
                        commitData={handleReceiveData.bind(this)} />
                ) : (
                    <BookingEvaluateDetail
                        bookingDetail={bookingDetail}
                        bookingDetailId={bookingDetailId}
                        commitData={handleReceiveData.bind(this)} />
                )
            )}
        </Modal>
    );
    return (
        <div className="subscribe-record">
            {/* 头部 */}
            <BookingHeader />
            <Content style={{ width: '1222px', margin: '0 auto' }}>
                <div className="subscribe-header">
                    <h3>预约记录</h3>
                    <Button
                        onClick={() => isEvaluationjump(true)}
                        type="primary"
                    >去预约</Button>
                </div>
                <Spin spinning={loading}>
                    <div className="site-layout-content">
                        <Tabs
                            defaultActiveKey={tabsKey}
                            onChange={callback}
                        >
                            {
                                tabData && tabData.map((item) => {
                                    return (
                                        <TabPane
                                            key={item.bookingType}
                                            tab={item.num !== 0 ? `${item.typeName}(${item.num})` : item.typeName} />
                                    );

                                })
                            }
                        </Tabs>
                        <Table
                            columns={columns}
                            dataSource={getListData}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: false,
                                current: currentTable,
                                total: totalSize,
                                onChange: (page) => {
                                    setCurrentTable(page);
                                },

                            }}
                            rowKey="id" />
                        {
                            getListData && getListData.length === 0 && <NoDataEmpty distance={200} />
                        }
                        {/* 详情modal */}
                        {BookingDetailModal}
                        {/* 评价modal */}
                        {BookingEvaluateModal}
                    </div>
                </Spin>
            </Content>
        </div>

    );
};

export default (SubscribeRecord);